<template>
  <div id="page-user-list" class="vx-card p-6">

    <!--      Search area-->
    <vx-card ref="filterCard" @keyup.enter="pressEnterSearch" id="user_list_filters" tabindex="0" title="" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">

      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ ﾊﾟﾀｰﾝ</label>
          <v-select class="w-full"
                    id="mail_type_search"
                    v-model="mail_type_search"
                    :options="listMailTypeSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">方法</label>
          <v-select class="w-full"
                    id="inquiry_type_search"
                    v-model="inquiry_type_search"
                    :options="listInquiryTypeSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">送信日時（から）</label>
          <flat-pickr id="sent_date_search_from"
                      class="w-full flatpickr-style"
                      v-model="sent_date_search_from"
                      placeholder="..."
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">送信日時（まで）</label>
          <flat-pickr id="sent_date_search_to"
                      class="w-full flatpickr-style"
                      v-model="sent_date_search_to"
                      placeholder="..."
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせID</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="receive_mail_id_search"
                    v-model="receive_mail_id_search"
                    icon-after="true" :icon="receive_mail_id_search ? iconVsInput : ''">
          </vs-input>
        </div>
        
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">担当者</label>
          <v-select :class="checkIsMultiple.mst_user ? 'w-full show-feature-x' : 'w-full'"
                    id="mst_user_search"
                    v-model="mst_user_search"
                    :options="listMstUserSelect"
                    placeholder="..."
                    :multiple="checkIsMultiple.mst_user"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listMstUserSelect => listMstUserSelect.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">状態</label>
          <v-select :class="checkIsMultiple.state_flg ? 'w-full show-feature-x' : 'w-full'"
                    id="state_flg_search"
                    v-model="state_flg_search"
                    :options="listSendMailSelectStateFlag"
                    placeholder="..."
                    :multiple="checkIsMultiple.state_flg"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listSendMailSelectStateFlag => listSendMailSelectStateFlag.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">種別</label>
          <v-select :class="checkIsMultiple.type ? 'w-full show-feature-x' : 'w-full'"
                    id="type_search"
                    v-model="type_search"
                    :options="listTypeSelect"
                     placeholder="..."
                    :multiple="checkIsMultiple.type"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listTypeSelect => listTypeSelect.value">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="subject_search"
                    v-model="subject_search" icon-after="true" :icon="subject_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">本文</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="body_search"
                    v-model="body_search" icon-after="true" :icon="body_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">TO メール</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="to_search__email_sender_search"
                    v-model="to_search__email_sender_search"
                    icon-after="true" :icon="to_search__email_sender_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">CC メール</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="cc_search__email_sender_search"
                    v-model="cc_search__email_sender_search" icon-after="true" :icon="cc_search__email_sender_search ? iconVsInput : ''">
          </vs-input>
        </div>
        <div class="vx-col flex flex-wrap justify-end m-auto mb-0 pt-4 w-full">
          <vs-button icon="assignment" @click="onSendReport" color="success">新規作成</vs-button>
          <vs-button icon="search" @click="onSearch(true)" color="primary" class="ml-2">検索 </vs-button>
        </div>
      </div>
    </vx-card>

     <!-- dialog state display -->
    <vs-popup ref="dialogConfirmState" title="表示カスタマイズ" :active.sync="activeStateDisplay" button-close-hidden>
      <div style="height: 100%">
          <ag-grid-vue
            id="myGrid1"
            :components="components"
            :gridOptions="gridOptionsState"
            class="ag-theme-material w-100 my-4 ag-grid-table database"
            :columnDefs="columnDefsState"
            :defaultColDef="defaultColDef"
            :rowData="listStateDisplayComputed"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="false"
            :domLayout="domLayout"
            @grid-ready="onGridReadyState"
            @selection-changed="onSelectionChangedState"
            @rowDragEnd="onSelectionChangedState"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
          ></ag-grid-vue>
      </div>
      <div class="flex justify-end">
            <vs-button @click="saveStateDisplay" color="success" icon="save" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
            <vs-button @click="activeStateDisplay = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">キャンセル</vs-button>
        </div>
      </vs-popup>

    <div class="flex flex-wrap items-center">
      <vs-row class="pb-2"
              style="align-items: center; justify-content: space-between;"
              vs-type="flex">
        <vs-col vs-w="4" class="flex items-center">
          <vs-col style="width: 111px" class="mr-3">
            <vs-switch v-model="modeComputed">
              <span slot="on">プレビュー</span>
              <span slot="off">プレビュー非表示</span>
            </vs-switch>
          </vs-col>
          <vs-col style="width: 200px" class="flex items-center justify-center">
            <div style="width: 35%;">
              表示件数:
            </div>
            <div style="width: 60%">
              <v-select class="square mr-2"
                        id="pagination_limit"
                        v-model="pagination.limit"
                        placeholder="..."
                        :options="listRowLimit"
                        :searchable="false">
              </v-select>
            </div>
          </vs-col>
        </vs-col>
        <vs-col vs-w="8"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
          <vs-button class="square mr-2"
                      color="#3287bf"
                      :disabled="modeComputed"
                      @click="activePopupState">
            <span>表示カスタマイズ</span>
          </vs-button>      
        </vs-col>
      </vs-row>
    </div>
    

    <!-- AgGrid Table -->
    <div v-if="!modeComputed">
      <ag-grid-vue
          id="myGrid"
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table database"
          :columnDefs="modifiedColumnsDefs"
          :defaultColDef="defaultColDef"
          :rowData="listMailSentComputed"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :domLayout="domLayout"
          :paginationPageSize="paginationPageSize"
          :isRowSelectable="isRowSelectable"
          @sort-changed="onSortChanged"
          @grid-ready="onGridReady"
          :enableRtl="$vs.rtl"
          :overlayNoRowsTemplate="noRowsTemplate"
          :suppressPaginationPanel="true"
          :detailRowAutoHeight="true">
      </ag-grid-vue>
      <div style="position: relative">
        <!-- ITEMS PER PAGE -->
        <div>
          <div class="flex items-center justify-between">
            <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
          </div>
        </div>
        <vs-pagination
            v-if="listMailSent.length > 0"
            :total="pagination.totalPage"
            :max="7"
            v-model="pagination.currentPage"
            class="pt-10 pr-10"
        />
      </div>
    </div>
    <!--Preview mode-->
    <vs-row v-else vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4">
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table database overflow-y-auto ag-grid-customize"
            :columnDefs="previewModeColumnDefs"
            :defaultColDef="defaultColDef"
            :rowData="listMailSentComputed"
            rowSelection="single"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :domLayout="domLayout"
            :paginationPageSize="paginationPageSize"
            :isRowSelectable="() => true"
            @sort-changed="onSortChanged"
            @grid-ready="onGridReady"
            @selection-changed="onPreviewModeSelectionChanged"
            :enableRtl="$vs.rtl"
            :overlayNoRowsTemplate="noRowsTemplate"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
            :getRowHeight="getRowHeight"
            :isFullWidthCell="isFullWidthCell"
            :fullWidthCellRenderer="fullWidthCellRenderer"
            style="max-height: 990px;"
            >
        </ag-grid-vue>

        <div style="position: relative">
          <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                  <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <vs-pagination
              v-if="listMailSent.length > 0"
              :total="pagination.totalPage"
              :max="7"
              v-model="pagination.currentPage"
              class="pt-10 pr-10"
            />
        </div>
      </vs-col>

      <!--Preview section-->
      <vs-col vs-w="7.75" id="receive-mail-detail" >
        <vs-row class="mt-5  py-2"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
              <vs-button class="square"
                    color="#4478b8"
                    @click="editMailDetail(preview_detail.id)"
                    :disabled="!preview_detail.id"
                    >
                <span><feather-icon icon="EditIcon" class="cursor-pointer" svg-classes="h-6 w-6"></feather-icon></span>
              </vs-button>
        </vs-row>
        <vs-row>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>方法</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.inquiry_type_text" placeholder="" />
              </vx-input-group>
          </vs-col>
          <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>種別</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.type_text" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>担当者</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.mst_user" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>From</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.email_sender" placeholder="" />
              </vx-input-group> 
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>To</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.to" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>CC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.cc" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>BCC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.bcc" />
              </vx-input-group> 
          </vs-col>
          <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style" style="width: 120px">
                  <span>添付ファイル</span>
                </div>
              </template>
              <vs-row>
                <vs-col
                  style="width: max-content; padding: 3px 5px"
                  :key="index"
                  v-for="(value, index) in preview_detail.attachmentFileName"
                >
                  <div @click="downloadAttachment(value.path)">
                    <vs-chip
                      style="cursor: pointer"
                      class="mt-1"
                      color="dark"
                      transparent
                      >{{ value.file_name }}</vs-chip
                    >
                  </div>
                </vs-col>
              </vs-row>
            </vx-input-group>
          </vs-col>
        </vs-row>

        <vs-row class="mt-6">
          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="件名"
          >
            <div
              class="w-full"
              v-html="preview_detail.subject"
              style="padding: 9.8px"
            ></div>
          </vx-card>

          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="お問い合わせ本文"
          >
            <div
            id="previewDetailBodyBlock"
              class="pl-2 pt-2"
              v-if="!preview_detail.body_type || preview_detail.body_type == 0"
              v-html="cleanedBodyPreviewDetail"
              style="height: 560px; overflow-y: scroll"
            ></div>
            <vs-textarea
            id="previewDetailBodyTextarea"
              v-else
              readonly
              v-model="preview_detail.body"
              placeholder="..."
              height="560px"
            />
          </vx-card>
        </vs-row>
      </vs-col>
    </vs-row>

  </div>
</template>
<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Japanese} from 'flatpickr/dist/l10n/ja.js';
import {mapActions, mapGetters, mapMutations} from 'vuex'
import CellRendererActions from "@/components/cell-renderer/CellRendererActions";
import CellRendererCheckbox from "@/components/cell-renderer/CellRendererCheckbox";
import EventBus from "../EventBus";
import {convertInquiryTypeToText, convertMailTypeToText, handleDownloadAttachment, setupIconClickEvent, convertLineBreakBody, getDateDefault} from "@/utils/helpler-utils";

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererActions,
    CellRendererCheckbox
  },
  data () {
    return {
      iconVsInput:'close',
      readOnly: false,
      isCreated: true,
      activeConfirm: false,
      activeStateDisplay: false,
      sent_date_search_from: '',
      sent_date_search_to: '',
      mail_type_search: {
        label: '...',
        value: ''
      },
      response_date_search: '',
      receive_mail_id_search: '',
      mst_user_search: {
        value: '',
        label: '...'
      },
      state_flg_search: {
        value: '',
        label: '...'
      },
      inquiry_type_search:  {
        value: '',
        label: '...'
      },
      subject_search: '',
      body_search: '',
      to_search__email_sender_search: '',
      cc_search__email_sender_search: '',
      type_search: {
        value: '',
        label: '...'
      },
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: ''
      },
      listSentUserNameSelect: [
        '...'
      ],
      listMstUserSelect: [
        {
          label: '...',
          value: ''
        }
      ],
      listMailTypeSelect: [
        {
          label: '...',
          value: ''
        },
        {
          label: '直接お問い合わせ',
          value: '0'
        },
        {
          label: '返信メール',
          value: '1'
        },
      ],
      listInquiryTypeSelect: [
        {
          label: '...',
          value: ''
        },
        {
          label: 'メール',
          value: '0'
        },
        {
          label: '電話',
          value: '1'
        },
        {
          label: '営業',
          value: '2'
        },
        {
          label: 'その他',
          value: '9'
        },
      ],
      listSendMailSelectStateFlag : [
        {
          label: '...',
          value: ''
        },
        {
          value: 0,
          label: '下書き'
        },
        {
          value: 1,
          label: '送信済'
        },
        {
          value: 2,
          label: '送信失敗'
        },

      ],
      listTypeSelect: [
        '...'
      ],

      startRow: 0,
      endRow: 0,
      pagination: {
        totalPage: 0,
        currentPage: this.searchFilter && this.searchFilter.queries && this.searchFilter.queries.page  ? this.searchFilter.queries.page:1,
        limit: 10,
        totalItem: 0,
        from: 1,
        to: 10
      },
      orderBy: 'sent_datetime',
      orderDir: 'desc',

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      columnApi: null,
      isRowSelectable: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
        onCellClicked: (cell) => {
          if (cell.value !== undefined){
            this.editMailDetail(cell.data.id)
          }
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: '方法',
          field: 'inquiry_type_text',
          width: 75,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '送信日時',
          field: 'sent_datetime',
          width: 150,
          unSortIcon: true,
          sort: 'desc',
          suppressMovable: true,
        },
        {
          headerName: 'お問い合わせID',
          field: 'receive_mail_id',
          width: 325,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '担当者',
          field: 'full_name',
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '状態',
          field: 'state_flg_text',
          width: 130,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '種別',
          field: 'type_text',
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        // {
        //   headerName: 'お問い合わせID',
        //   field: 'inquiry_id',
        //   width: 150,
        //   unSortIcon: true,
        //   suppressMovable: true,
        // },
        // {
        //   headerName: 'お問い合わせ者',
        //   field: 'email_sender',
        //   width: 200,
        //   // cellClass: 'text-center',
        //   unSortIcon: true,
        //   suppressMovable: true,
        // },
        {
          headerName: 'タイトル',
          field: 'subject',
          width: 300,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'メール本文',
          field: 'body',
          width: 300,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],

      type_mail: 1, //'0: 受信 | 1:送信'
      gridApiState: null,
      columnApiState: null,
      listStateDisplaySelect: ['方法','送信日時','お問い合わせID',
      '担当者','状態','種別','タイトル','メール本文'],
      data_display:[],
      gridOptionsState: {
        rowDragManaged: true,
        suppressRowClickSelection: true,
      },
      columnDefsState: [
        {
          headerName: '',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          
        },
        {
          headerName: '表示順',
          width: 100,
          rowDrag: true,
          suppressSorting : true 
          
        },
        {
          headerName: 'ヘッダ名称',
          field: 'content',
          width: 400,
          suppressSorting : true 
        },
      ],
      sort_display:[],
      list_state_display_default:[
        {content: '方法'},
        {content: '送信日時'},
        {content: 'お問い合わせID'},
        {content: '担当者'},
        {content: '状態'},
        {content: '種別'},
        {content: 'タイトル'},
        {content: 'メール本文'},
      ],
      // Cell Renderer Components
      components: {
        CellRendererActions
      },
      //CheckMultiple v-Select
      checkIsMultiple: {
        state_flg: false,
        mst_user : false,
        type     : false,
      },
      //Preview Mode
      previewModeColumnDefs: [
        {
          headerName: "",
          field: "id",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      getRowHeight: null,
      fullWidthCellRenderer: null,
      isFullWidthCell: null,
      selectedPreviewMail: {},

      //PAC_21-91
      listRowLimit: [
        '10',
        '25',
        '50'
      ]
    }
  },
  watch: {
    'pagination.limit': function () {
      this.pagination.currentPage = 1;
      this.onSearch(false);
    },
    async $route (to, from){
      /* start loading with many requests */
      this.$store.dispatch('updateLoads', true)
      this.clearSearchFilter()
      let mailBox = this.$route.params.email;
      if (mailBox){

      }else if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name
      }
      if (mailBox) {
        this.setDefaultSearchOption()
        this.orderBy = 'sent_datetime'
        this.orderDir = 'desc'
        this.gridApi.setSortModel({colId: 'sent_datetime', sort: 'desc'})
        await this.getListMstUserSelect()
        await this.getListMailBox()
        await this.getListKindsSelect()
        await this.onSearch(true, mailBox)
      }

      /* stop loads */
      this.$store.dispatch('updateLoads', false)
    },
    inquiry_id_search(val){
      if(val < 0) return this.inquiry_id_search = null
    },
    'pagination.currentPage':{
      deep: true,
      immediate: true,
      handler: function(val){
        if(!this.isCreated) this.paginationPage(val)
      }
    }
  },
  beforeMount() {
    this.isRowSelectable = (params) => {
      let data = params.data
      if (data && data.mst_user_id === null && data.state_flg === 0) {
        return true
      } else {
        return false
      }
    },
    this.isFullWidthCell = (rowNode) => {
        if (this.mode == true) {
          return rowNode.data;
        }
    },
    this.fullWidthCellRenderer = (params) => {
        let to = params.data.to ? params.data.to.split(",") : null;
        if (to && to.length > 1) to = to[0] + ', ...';
        else if (to && to.length == 1) to = params.data.to;
        else to = '';
        let subject = params.data.subject || "";

        let cellClass = "cell-full-width ";
        const eDiv = document.createElement("div");
        eDiv.innerHTML = `<div class=${cellClass}>
          <div class="mail-header">
            <span>${to}</span>
            <span>${params.data.sent_datetime}</span>
          </div>
          <br><span style="font-size:15px; line-height: 1.5">${subject}</span></div>
        </div>`;
        return eDiv.firstChild;
    };
    this.getRowHeight = () => {
      if (this.mode == true) {
        return 85;
      } else {
        return 50;
      }
    };
  },
  computed: {
    ...mapGetters({
      listMailBox: 'receiveMail/listMailBox',
      currentMailBoxSelected: 'receiveMail/currentMailBoxSelected',
      listMailSent:  'mailSent/listMailSent',
      searchFilter: 'mailSent/getSearchFilter',
      listUserSetting: 'userSetting/listUserSetting',
      mode: "mailSent/mode",
    }),
    paginationPageSize () {
      // if (this.gridApi) return this.gridApi.paginationGetPageSize();
      // else return 10;
      return this.pagination.limit
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    totalRow(){
      return parseInt(this.pagination.totalItem)
    },
    listMailSentComputed () {
      let listMailSent = []
      this.listMailSent.forEach((element) => {
        let body = ''
        body = element.body ? element.body.trim() : '';
        listMailSent.push(Object.assign({...element,body: body}));
      });
      return listMailSent
      
    },
    listStateDisplayComputed () {
      let listStateDisplay = []
      if (!this.listUserSetting || this.listUserSetting.length == 0 || !this.listUserSetting.sort_display)
        listStateDisplay = this.list_state_display_default
      else{
          let list = this.listUserSetting.sort_display.split(";")
          list.forEach((element) => {
              if (element != ''){
                listStateDisplay.push(Object.assign({content: element}))
              }
          });
      }
      return listStateDisplay
    },

    modifiedColumnsDefs(){
      let modifiedColumnsDefs =[]
      if (!this.listUserSetting || this.listUserSetting.length == 0 || !this.listUserSetting.header_display) 
        modifiedColumnsDefs = this.columnDefs
      else{
        let modifiedcolumns  = this.columnDefs
        let listmodified = this.listUserSetting.header_display.split(";")
        listmodified.forEach(function(modify, index){
          modifiedcolumns.forEach(function(column, index){
            if (column.headerName == modify && modify != ''){
                modifiedColumnsDefs.push(column)
            }
          })
        })
      }
      return modifiedColumnsDefs
    },
    preview_detail() {
      return this.selectedPreviewMail ? this.selectedPreviewMail : {};
    },
    modeComputed: {
      get() {
        return this.mode;
      },
      async set() {
        await this.setMode();
      },
    },
    cleanedBodyPreviewDetail() {
        return convertLineBreakBody(this.preview_detail.body);
    },
  },
  methods: {
    ...mapActions({
      // getMailReceive: 'receiveMail/getMailReceive',
      getListUserDataSelect: 'receiveMail/getListUserDataSelect',
      getListMailServerSentUser: 'receiveMail/getListMailServerSentUser',
      // updateMailReceived: 'receiveMail/updateMailReceived',
      getListMailBox: 'receiveMail/getListMailBox',
      getListMailSent: 'mailSent/getListMailSent',
      getListKinds: 'kinds/getListKinds',
      clearSearchFilter: 'mailSent/clearSearchFilter',
      clearSearchFilterReceive: 'receiveMail/clearSearchFilter',
      saveUserSetting: 'userSetting/saveUserSetting',
      getUserSetting: 'userSetting/getUserSetting',
      refreshUserSetting: 'userSetting/refreshUserSetting',
      setMode: "mailSent/setMode",
      getSelectedMailPreviewMode: "moduleEmail/getSelectedMailPreviewMode",
      downloadFile: "receiveMail/downloadAttachment",
      setUserReadOnly: "receiveMail/setUserReadOnly",
    }),
    ...mapMutations({
      setSearchFilter: 'mailSent/SET_SEARCH_FILTER',
    }),
    pressEnterSearch() {
      this.onSearch(true)
    },
    clearInput(modelExpression) {
      this[modelExpression] = ""; // Clear the value
    },
    clearFocusTypeDropdown() {
      this.$nextTick(() => {
        document.activeElement.blur()
        document.getElementById('user_list_filters').focus()
      })
    },
    async paginationPage(value) {
      if(!this.isCreated){
        this.pagination.currentPage = value
        let mailBox = this.$route.params.email;
        if (mailBox){

        }else if (this.listMailBox && this.listMailBox.length > 0) {
          mailBox = this.listMailBox[0].receive_user_name
        }
        await this.onSearch(false, mailBox)
      }
    },
    onSelectionChangedState() {
      //get selected rows
      let selectedStates = this.gridApiState.getSelectedRows()
      let listStateSelected = []
      selectedStates.forEach(function (selectedState, index) {
        listStateSelected.push(selectedState.content)
      })
      //get index when row drag
      let list = this.rowDragChanged();
      let orderedSelectedList = list.filter(ele => listStateSelected.indexOf(ele) >= 0);
      this.listStateDisplaySelect = orderedSelectedList;
    
    },
    rowDragChanged(){
      let rowData = [];
      let list = []
      this.gridApiState.forEachNode(node => rowData.push(node.data));
      rowData.forEach(function (row, index) {
        list.push(row.content)
      })
      this.sort_display = list
      return list;
    },
    onSortChanged(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this
      columns.forEach(function(column) {
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy = column.getColId()
          root.onSearch(false)
        }
      })
    },
    updateSortParams(orderBy, orderDir) {
      this.orderBy = orderBy
      this.orderDir = orderDir
    },
    async getListMstUserSelect() {
      let mailBoxInfo = await this.listMailBox.find(element => element.receive_user_name == this.currentMailBoxSelected)
      if (mailBoxInfo) {
        let params = {
          'mst_mail_server_id': mailBoxInfo.id
        }
        let response = await this.getListUserDataSelect(params)
        if (response) {
          this.listMstUserSelect = [
            {
              label: '...',
              value: ''
            }
          ]
          response.map(element => {
            let result = { }
            result.value = element.id
            result.label = element.full_name
            this.listMstUserSelect.push(result)
          })
        } else {
          this.listMstUserSelect = [
            {
              label: '...',
              value: ''
            }
          ]
        }
      }

    },
    onSendReport(){
      // this.$router.push(`/sent/${this.currentMailBoxSelected}/create-mail`)
      let routePath = `/sent/${this.currentMailBoxSelected}/create-mail?back=true`;
      window.open(routePath, '_blank');
    },
    async onSearch(resetPaging, mailBox = null) {
      let mst_user_id = ''
      if (this.checkIsMultiple.mst_user) {
        if (this.mst_user_search && this.mst_user_search.length && this.mst_user_search.length > 0) {
          mst_user_id = this.mst_user_search
        }
      } else {
        if (this.mst_user_search) {
          mst_user_id = this.mst_user_search.value
        }
      }
      let state_flg = ''
      if (this.checkIsMultiple.state_flg) {
        if (this.state_flg_search && this.state_flg_search.length && this.state_flg_search.length > 0) {
          state_flg = this.state_flg_search
        }
      } else {
        if (this.state_flg_search) {
          state_flg = this.state_flg_search.value
        }
      }
      let mail_type = ''
      if (this.mail_type_search) {
        mail_type = this.mail_type_search.value
      }
      let inquiry_type = ''
      if (this.inquiry_type_search) {
        inquiry_type = this.inquiry_type_search.value
      }
      let type = ''
      if (this.checkIsMultiple.type) {
        if (this.type_search && this.type_search.length && this.type_search.length > 0) {
          type = this.type_search
        }
      } else {
        if (this.type_search) {
          type = this.type_search.value
        }
      }
      let action = ''
      if (resetPaging === true && mailBox === null) {
        action = 'search'
      }
      if (mailBox === null) {
        mailBox = this.currentMailBoxSelected
      } else {
        this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', mailBox)
      }
      // process order by
      if (this.orderBy) {
        if (this.orderBy === 'state_flg_text') {
          this.orderBy = 'state_flg'
        }
        if (this.orderBy === 'inquiry_type_text') {
          this.orderBy = 'inquiry_type'
        }
        if (this.orderBy === 'type_text') {
          this.orderBy = 'type'
        }
      }
      let page = this.pagination.currentPage
      if(resetPaging === true) page = 1
      if(this.isCreated) page = this.searchFilter && this.searchFilter.mailBox === mailBox ? this.searchFilter.queries.page : 1 
      let params = {
        mailBox: mailBox,
        queries: {
          inquiry_type: inquiry_type,
          sent_datetime_from: this.sent_date_search_from || getDateDefault(),
          sent_datetime_to: this.sent_date_search_to || getDateDefault('to'),
          mail_type: mail_type,
          // response_limit: this.response_date_search,
          receive_mail_id: this.receive_mail_id_search,
          mst_user_id: mst_user_id,
          // receive_mail_email_sender: this.receive_mail__email_sender_search,
          // state_flg_receive_mail: state_flg_receive_mail,
          state_flg: state_flg,
          subject: this.subject_search,
          body: this.body_search,
          type: type,
          action: action,
          page: page,
          limit: this.pagination.limit,
          orderBy: this.orderBy,
          orderDir: this.orderDir,
          to: this.to_search__email_sender_search,
          cc: this.cc_search__email_sender_search,
        }
      }
      let data = await this.getListMailSent(params)
      this.setSearchFilter(params)

      this.pagination.totalItem = data.total;
      this.pagination.totalPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.limit = data.per_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;

      //Load preview mode
      if (this.mode) this.loadPreview();
    },
    clearSearchOption() {
      this.mail_type_search = ''
      this.clearSearchCommon()
    },
    setDefaultSearchOption() {
      this.mail_type_search = {
        label: '直接お問い合わせ',
        value: '0'
      }
      this.clearSearchCommon()
    },
    clearSearchCommon() {
      this.sent_date_search_from = getDateDefault();
      this.sent_date_search_to = getDateDefault('to');
      this.response_date_search = ''
      this.receive_mail_id_search = ''
      this.inquiry_id_search = ''
      this.mst_user_search = ''

      this.inquiry_type_search = {
        value: '',
        label: '...'
      }
      this.state_flg_search = {
        value: '',
        label: '...'
      }
      this.type_search = {
        value: '',
        label: '...'
      }
      this.subject_search = ''
      this.body_search    = ''
      this.to_search__email_sender_search = '';
      this.cc_search__email_sender_search = '';
        //CheckMultiple v-Select
      this.checkIsMultiple = {
        state_flg: false,
        mst_user : false,
        type     : false,
      }
    },
    async getListKindsSelect() {
      let response = await this.getListKinds()
      if (response) {
        
        this.listTypeSelect = [
              {
                label: '...',
                value: ''
              }
        ]
        response.map(element => {
          let result = { }
          result.value = element.type_id
          result.label = element.kinds_name
          this.listTypeSelect.push(result)
        })
      } else {
        this.listTypeSelect = [
            {
              label: '...',
              value: ''
            }
        ]
      }
    },
    async resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.clearSearchFilter()
      this.clearSearchOption()
      await this.onSearch(true)
      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      if (this.mode) {
        this.loadPreview();
      }
    },
    onGridReadyState(params) {
      this.gridApiState = params.api 
      this.columnApiState = params.columnApi
    },
    mailBoxSelectable(){
      let mailBox = this.listMailBox.find(item => item.receive_user_name === this.$route.params.email)
      if(!mailBox.numberMailNotSupport) document.getElementsByClassName('ag-header-select-all ag-labeled ag-label-align-right ag-checkbox')[0].style.opacity = '0.5'
      else document.getElementsByClassName('ag-header-select-all ag-labeled ag-label-align-right ag-checkbox')[0].style.opacity = '1'
    },
    async saveStateDisplay () {
      let params = {
        header_display: this.listStateDisplaySelect,
        sort_display: this.sort_display,
        type: this.type_mail
      }
      if (await this.saveUserSetting(params) == true){
        this.activeStateDisplay = false
        await this.loadDisplay()
        this.gridApi.sizeColumnsToFit();
      }    
    },
    async activePopupState() {
      this.activeStateDisplay = true
      let dataDisplay = await this.refreshUserSetting(this.listUserSetting);
      this.loadCheckBox(dataDisplay)
      this.gridApi.sizeColumnsToFit()
    },

    async loadDisplay(){
      //get setting display
      let dataDisplay =await this.getUserSetting(this.type_mail)
      this.loadCheckBox(dataDisplay)
    },
    loadCheckBox(data) {
      this.data_display = data
      this.gridColumnApi.resetColumnState();
      if (!this.data_display){
        this.gridApiState.forEachNode(function (node) {  
            node.setSelected(true)
          });
      }
      else{
        let listDisplay = this.data_display.header_display.split(";")
        this.gridApiState.forEachNode(function (node) {  
          node.setSelected(listDisplay.indexOf(node.data.content) >= 0)
        });
      }
    },
    async refreshPage() {
      if (localStorage.refreshPage) {
        if (localStorage.refreshPage == 'draft'){
          localStorage.removeItem("refreshPage");
        } else{
          localStorage.removeItem("refreshPage");
          let mailBox = this.$route.params.email;
          if (mailBox) {
            await this.onSearch(false, mailBox)
          }
        }
      }
    },
    selectionChangedvSelect(){
      if (this.state_flg_search && this.state_flg_search.length >= 0) {
        if (this.state_flg_search.includes('') || this.state_flg_search.length == 0) {
          this.state_flg_search = [];
        }
      }
      if (this.mst_user_search && this.mst_user_search.length >= 0) {
        if (this.mst_user_search.includes('') || this.mst_user_search.length == 0) {
          this.mst_user_search = [];
        }
      }
      if (this.type_search && this.type_search.length >= 0) {
        if (this.type_search.includes('') || this.type_search.length == 0) {
          this.type_search = [];
        }
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    openvSelect(){
      if (!this.checkIsMultiple.state_flg) {
        this.checkIsMultiple.state_flg = true;
      }
      if (!this.checkIsMultiple.mst_user) {
        this.checkIsMultiple.mst_user = true;
      }
      if (!this.checkIsMultiple.type) {
        this.checkIsMultiple.type = true;
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    checkSelected() {
      let mst_user    = document.querySelectorAll('#mst_user_search>ul>li');
      let state_flg   = document.querySelectorAll('#state_flg_search>ul>li');
      let type_search = document.querySelectorAll('#type_search>ul>li');
      if (mst_user && mst_user.length > 0) {
        mst_user.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
      if (state_flg && state_flg.length > 0) {
        state_flg.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
       if (type_search && type_search.length > 0) {
        type_search.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }    
    },
    async onPreviewModeSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      let params = {
        mailBox: this.$route.params.email,
        id: selectedRows[0].id,
        type: 1
      }
      let selectedPreviewMail = await this.getSelectedMailPreviewMode(params);
      selectedPreviewMail.inquiry_type_text = convertInquiryTypeToText(selectedPreviewMail.inquiry_type)
      selectedPreviewMail.type_text = convertMailTypeToText(null, selectedPreviewMail.kinds_name, selectedPreviewMail.kinds_state)
      selectedPreviewMail.mst_user = selectedRows[0].full_name
      selectedPreviewMail.attachmentFileName = [];
      if (selectedPreviewMail.attachment_filepath){
        let listattachmentFiles = selectedPreviewMail.attachment_filepath.split(',')
        listattachmentFiles.forEach((element)=>{
        selectedPreviewMail.attachmentFileName.push({
            path: element,
            file_name: element.split('/').reverse()[0]
          })
        });
      }
      this.selectedPreviewMail = selectedPreviewMail;
      if(this.preview_detail.body_type) {
        const topScrollElement = document.getElementById('previewDetailBodyTextarea')
        topScrollElement.scrollTop = 0;
      }
      else {
        const topScrollElement = document.getElementById('previewDetailBodyBlock')
        topScrollElement.scrollTop = 0;
      }
    },
    loadPreview() {
      if (this.selectedPreviewMail) {
        let isNewPage = true;
        this.gridApi.forEachNode((node) => {
          isNewPage =
            this.selectedPreviewMail.id == node.data.id ? false : isNewPage;
          node.setSelected(
            this.selectedPreviewMail.id == node.data.id,
            true,
            true
          ); //Prevent call back to onPreviewModeSelectionChanged
        });
        //Set node[0] when direct to new page
        if (isNewPage && this.gridApi.getRowNode(0)) this.gridApi.getRowNode(0).setSelected(true);
        else if (this.listMailSent && this.listMailSent.length == 0) this.selectedPreviewMail = {};
      } else {
        this.gridApi.getRowNode(0).setSelected(true);
      }
    },
    async downloadAttachment(file) {
      let data = {
        "id" : this.preview_detail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
        handleDownloadAttachment(result);
      }
    },
    editMailDetail(mail_id) {
      let routePath = `/sent/${this.$route.params.email}/${mail_id}?back=true`;
      window.open(routePath, '_blank');
    },
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    this.mailBoxSelectable()
    this.clearSearchFilterReceive()
    // addEventListener Reload => clear
    window.addEventListener('beforeunload', this.resetColFilters)
    window.addEventListener('storage', this.refreshPage);
    setupIconClickEvent();
  },
  async created () {
    /* start loading with many requests */
    this.$store.dispatch('updateLoads', true)

    let mailBox = this.$route.params.email;
    await this.getListMailBox()
    if(!mailBox){
      if (this.listMailBox && this.listMailBox.length > 0){
        mailBox = this.listMailBox[0].receive_user_name
      }
    }
    else{
      if(this.listMailBox && this.listMailBox.length > 0 && this.listMailBox.find(mb => mb.receive_user_name == mailBox)){
        //...
      }
      else  mailBox = null
    }
    await this.getListMstUserSelect()
    await this.getListKindsSelect()
    if (mailBox) {
      this.sent_date_search_from = getDateDefault();
      this.sent_date_search_to = getDateDefault('to');
      if (!this.listUserSetting || this.listUserSetting.length == 0){
        await this.loadDisplay()
      }else{
        if (this.listUserSetting.type_mail == 0) await this.loadDisplay();
      }
      await this.getUserSetting(this.type_mail)
      this.gridApi.sizeColumnsToFit();
      if (!this.listUserSetting || this.listUserSetting.length == 0){
        this.sort_display = this.listStateDisplaySelect
        await this.saveStateDisplay()
      }
      if(this.searchFilter && this.searchFilter.queries && this.searchFilter.mailBox && this.searchFilter.mailBox === mailBox){
        this.subject_search = this.searchFilter.queries.subject ? this.searchFilter.queries.subject : ''
        this.body_search = this.searchFilter.queries.body ? this.searchFilter.queries.body : ''
        this.mail_type_search = this.listMailTypeSelect.find(type => type.value === this.searchFilter.queries.mail_type)
        this.inquiry_type_search = this.listInquiryTypeSelect.find(inquiry => inquiry.value === this.searchFilter.queries.inquiry_type)
        this.mst_user_search = this.listMstUserSelect.find(user => user.value === this.searchFilter.queries.mst_user_id)
        this.email_sender_search = this.searchFilter.queries.email_sender ? this.searchFilter.queries.email_sender : '...'
        this.type_search = this.listTypeSelect.find(type => type.value === this.searchFilter.queries.type)
        this.state_flg_search = this.listSendMailSelectStateFlag.find(state => state.value === this.searchFilter.queries.state_flg)
        this.pagination.limit = this.searchFilter.queries.limit ? this.searchFilter.queries.limit:10
        this.sent_date_search_from = this.searchFilter.queries.sent_datetime_from || this.sent_date_search_from
        this.sent_date_search_to = this.searchFilter.queries.sent_datetime_to || this.sent_date_search_to
        this.orderBy = this.searchFilter.queries.orderBy ? this.searchFilter.queries.orderBy : 'receive_datetime'
        this.orderDir = this.searchFilter.queries.orderDir ? this.searchFilter.queries.orderDir : 'asc'
        this.to_search__email_sender_search = this.searchFilter.queries.to ? this.searchFilter.queries.to : '';
        this.cc_search__email_sender_search = this.searchFilter.queries.cc ? this.searchFilter.queries.cc : '';
      }
      await this.onSearch(false, mailBox)
      this.isCreated = false
    }
    else this.$router.push({ path: '/dashboard'})
    
    /* stop loads */
    this.readOnly = await this.setUserReadOnly(mailBox) > 0;
    this.$store.dispatch('updateLoads', false)
  },
  updated () {
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.listMailSent.length > 0){
        this.startRow = this.pagination.currentPage * this.pagination.limit - this.pagination.limit + 1
        if(this.listMailSent.length == this.pagination.limit) this.endRow = this.pagination.currentPage*this.pagination.limit
        else this.endRow = this.pagination.limit*this.pagination.currentPage + this.listMailSent.length - this.pagination.limit
      }
      else if(this.listMailSent.length == 0){
        this.pagination.totalItem = 0;
        this.startRow = 0
        this.endRow = 0
      }
    });
    this.mailBoxSelectable()
  },
  beforeDestroy(){
    window.removeEventListener('beforeunload', this.resetColFilters, {passive: true})
    window.removeEventListener("storage", this.refreshPage)
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
@import "@/assets/scss/vuexy/components/view/mailBox.scss"
</style>
